import React, { useState } from 'react';
import { getMapUrls, formatPrice } from '../utils/eventDisplayUtils'; // Import formatPrice
import EventAvailabilityBar from './EventAvailabilityBar';

const EventRow = ({
  row,
  eventKey,
  isExpanded,
  onToggleExpand,
  copyToClipboard
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleToggleExpand = () => {
    setIsAnimating(true);
    onToggleExpand();
  };

  const mapUrls = getMapUrls(row);

  // Helper to trim "Australia" from address and whitespace
  const getTrimmedAddress = (address) => {
    if (!address) return '';
    return address.replace(/,\s*australia\s*$/i, '').trim();
  };

  return (
    <tr className="hover:bg-gray-50">
      {/* Event Column */}
      <td className="border border-gray-300 px-2 py-2 w-full text-sm align-top overflow-hidden">
        {/* Availability Bar */}
        <div onClick={handleToggleExpand} className="cursor-pointer">
          <EventAvailabilityBar row={row} />
        </div>
        <div
          className={`transition-[max-height] duration-300 ease-in-out overflow-hidden ${isExpanded ? 'max-h-[500px]' : 'max-h-0'}`} // Adjusted max-height for animation
          onTransitionEnd={() => setIsAnimating(false)}
        >
          <div className={`mt-2 px-2 text-xs space-y-1 ${isExpanded || isAnimating ? 'block' : 'hidden'}`}> {/* Ensure content is always rendered */}
            <div className="font-bold break-words">
              {row.groupName}
              {row.priceRange !== 'N/A' && (
                <span className="ml-2 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5 whitespace-normal">
                  {formatPrice(row.priceRange)} {/* Use formatPrice */}
                </span>
              )}
            </div>
            <div className="text-gray-700">{row.difficulty}</div>
            <div className="text-gray-700">
              <div className="flex items-center gap-1"> {/* Changed to items-center for vertical alignment */}
                <span className="break-words mr-1">
                  {getTrimmedAddress(row.address)} {/* Trimmed address */}
                </span>
                <div className="flex items-center gap-1"> {/* Ensures buttons are aligned */}
                  <button
                    onClick={() => {
                      const trimmed = getTrimmedAddress(row.address);
                      copyToClipboard(trimmed);
                    }}
                    title="Copy address"
                    className="text-blue-600 hover:text-blue-800 text-xs p-0.5 rounded focus:outline-none focus:ring-1 focus:ring-blue-300 inline-flex items-center justify-center"
                    aria-label="Copy address to clipboard"
                    type="button"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  </button>
                  {/* Google Maps button */}
                  <a
                    href={mapUrls.google}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open in Google Maps"
                    className="inline-flex items-center justify-center border border-blue-200 hover:border-blue-300 rounded p-0.5"
                    style={{ width: 22, height: 22 }}
                  >
                    <img
                      src="https://www.google.com/images/branding/product/ico/maps15_bnuw3a_32dp.ico"
                      alt="Google Maps"
                      className="w-4 h-4"
                    />
                  </a>
                  {/* Apple Maps button */}
                  <a
                    href={mapUrls.apple}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open in Apple Maps"
                    className="inline-flex items-center justify-center border border-blue-200 hover:border-blue-300 rounded p-0.5"
                    style={{ width: 22, height: 22 }}
                  >
                    <img
                      src="https://www.apple.com/favicon.ico"
                      alt="Apple Maps"
                      className="w-4 h-4"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default EventRow;
